import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PenLine } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { formatDate, formatInt, lazyPage } from "@vixio/ui";
import "./api";
import type { EnvelopeView } from "./api";
import { useEnvelopeKpis } from "./widget-data";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const EnvelopesPage = lazyPage(() => import("./EnvelopesPage"), "EnvelopesPage");
const EnvelopePage = lazyPage(() => import("./EnvelopePage"), "EnvelopePage");
const SignPage = lazyPage(() => import("./SignPage"), "SignPage");
const ValidatePage = lazyPage(() => import("./ValidatePage"), "ValidatePage");

function SignaturesWidget() {
  const org = useOrg();
  const k = useEnvelopeKpis(org.id).data;
  const pending = useQuery({
    queryKey: ["signatures", "widget", org.id],
    queryFn: () =>
      unwrap<Array<Pick<EnvelopeView, "id" | "title" | "next_signer" | "expires_at" | "signers_signed" | "signers_total">>>(from("signatures", "v_envelopes").select("id, title, next_signer, expires_at, signers_signed, signers_total").eq("org_id", org.id).eq("status", "sent").order("expires_at").limit(4)),
  });
  return (
    <div className="vx-stack">
      <dl className="vx-dl">
        <dt>Aguardando</dt>
        <dd className="num">{formatInt(k?.sent ?? 0)}</dd>
        <dt>Concluídos no mês</dt>
        <dd className="num">{formatInt(k?.completedMonth ?? 0)}</dd>
      </dl>
      {(pending.data ?? []).length ? (
        <ul className="vx-stack" style={{ gap: 6, margin: 0, padding: 0, listStyle: "none" }}>
          {(pending.data ?? []).map((e) => (
            <li key={e.id} style={{ minWidth: 0 }}>
              <Link to={`/documentos/assinaturas/${e.id}`}>{e.title}</Link>
              <span className="text-2 num">
                {" "}
                · {e.signers_signed}/{e.signers_total}, até {formatDate(e.expires_at)}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
      <Link to="/documentos/assinaturas">Abrir assinaturas</Link>
    </div>
  );
}

export default defineModuleUi({
  key: "signatures",
  title: "Assinatura eletrônica",
  domain: "documents",
  icon: PenLine,
  menu: [{ path: "/documentos/assinaturas", label: "Assinaturas", minRole: "member", icon: PenLine, order: 30, keywords: "envelope signatário assinar manifesto trilha lei 14.063" }],
  routes: [
    { path: "/documentos/assinaturas", element: <EnvelopesPage />, minRole: "member" },
    { path: "/documentos/assinaturas/:id", element: <EnvelopePage />, minRole: "member" },
  ],
  publicRoutes: [
    { path: "/assinar/:token", element: <SignPage /> },
    { path: "/validar", element: <ValidatePage /> },
    { path: "/validar/:code", element: <ValidatePage /> },
  ],
  widgets: [{ key: "signatures.pending", title: "Assinaturas", minRole: "member", span: 1, order: 40, element: SignaturesWidget }],
});
